import {PtrnTiposCampo} from './patronTypes';

export enum FORMATS {
   date = 'dd/MM/yyyy',
   time = 'HH:mm',
   datetime = 'dd/MM/yyyy HH:mm',
   formatoPeriodo = 'yyyy-MM'
}
export enum DateViews {
   day = 'day',
   month = 'month',
   year = 'year'
}

export enum TimeViews {
   hours = 'hours',
   minutes = 'minutes',
   seconds = 'seconds'
}
export const DEFAULTS_VALUES = {
   NO_CONFIG_FIELD: {tipo: PtrnTiposCampo.string, name: 'no_config_field'}
};

export const PTRN_TIPO_NO_VALUE = [
   PtrnTiposCampo.grupo,
   PtrnTiposCampo.calculado,
   PtrnTiposCampo.tab,
   PtrnTiposCampo.tabgroup
];
